import React from 'react';

import bgColors from 'src/styles/bgColors.module.scss';
import layout from 'src/styles/layout.module.scss';

import styles from './card.module.scss';
import { CardVariant } from 'src/types/card-variant.enum';
import BackgroundBanner from 'src/components/atomic/atoms/backgroundBanner/BackgroundBanner';

interface Props {
    variant?: CardVariant; // TODO depricate this prop, it's not that useful
    icon?: JSX.Element;
    heading?: JSX.Element;
    row?: boolean;
    className?: string;
    children: JSX.Element | JSX.Element[];
    showBackgroundBanner?: boolean;
}

export default function Card({
    variant = CardVariant.PRIMARY,
    icon,
    heading,
    row,
    className,
    children,
    showBackgroundBanner,
    ...props
}: Props): JSX.Element {
    let cardClassName: string = styles.card;
    switch (variant) {
        case CardVariant.PRIMARY:
            cardClassName += ` ${bgColors.backgroundLight}`;
            break;
        case CardVariant.SECONDARY:
            cardClassName += ` ${bgColors.backgroundWeak} ${layout.border}`;
            break;
        case CardVariant.TERTIARY:
            cardClassName += ` ${bgColors.backgroundHighlight}`;
            break;
        default:
            break;
    }

    if (!row) cardClassName += ` ${styles.column}`;
    if (className) cardClassName += ` ${className}`;

    const card: JSX.Element = (
        <div className={cardClassName} {...props}>
            {(icon || heading) && (
                <div className={styles.iconHeading}>
                    {icon}
                    {heading}
                </div>
            )}
            {children}
        </div>
    );

    return showBackgroundBanner ? <BackgroundBanner>{card}</BackgroundBanner> : card;
}
